import { render } from "./CardFourtyFour.vue?vue&type=template&id=0660944e"
import script from "./CardFourtyFour.vue?vue&type=script&lang=js"
export * from "./CardFourtyFour.vue?vue&type=script&lang=js"

import "./CardFourtyFour.vue?vue&type=style&index=0&id=0660944e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__